"use strict";

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.function.name.js");

var _antd = require("antd");

var _useMainTabs2 = _interopRequireDefault(require("../../../../hooks/ui/useMainTabs"));

require("./MainTabs.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Tabs component to allow the user to dynamically add/remove tabs to the application:
 * <ul>
 * <li>
 *      See <a href="https://ant.design/components/tabs/">Antd Documentation</a> 
 *      for more details about the available properties.
 * </li>
 * </ul>
 *
* @visibleName Main Tabs
 */
var MainTabs = function MainTabs(props) {
  var _useMainTabs = (0, _useMainTabs2.default)(),
      tabs = _useMainTabs.tabs;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs, _objectSpread(_objectSpread({}, props), {}, {
    style: {
      marginLeft: 3,
      height: '100%',
      width: '100%'
    },
    children: tabs.map(function (tabItem) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs.TabPane, {
        tab: tabItem.name,
        style: {
          height: '100%',
          width: '100%'
        },
        children: tabItem.tab
      }, tabItem.key);
    })
  }));
};

MainTabs.propTypes = {};
var _default = MainTabs;
exports.default = _default;